import * as __WEBPACK_EXTERNAL_MODULE__margin_prop_js_86b53c2e__ from "./margin.prop.js";
import * as __WEBPACK_EXTERNAL_MODULE__padding_prop_js_b386567b__ from "./padding.prop.js";
const sharedStyles = {
    cx: {
        ...__WEBPACK_EXTERNAL_MODULE__padding_prop_js_b386567b__.paddingStyles,
        ...__WEBPACK_EXTERNAL_MODULE__margin_prop_js_86b53c2e__.marginStyles
    }
};
export { sharedStyles };

//# sourceMappingURL=shared.prop.js.map